import createTypes from 'redux-create-action-types';

export default createTypes('DUMMY_REDUX_EVENT', 'DUMMY_REDUX_ASYNC');
